import { find, includes, map } from 'lodash';
import { createSelector } from 'reselect';
import { ROUTE_PREFIX_CATEGORIES } from '../../constants/route-prefix';
import { getMixedIds, getMixedIdsMap } from '../../services';
import { getInternalLinkRoute } from '../../services/get-internal-link-route';
export const getCategories = (state) => { var _a; return (_a = state.categories) !== null && _a !== void 0 ? _a : []; };
export const getCategoriesSlice = createSelector([getCategories, (_, size) => size], (categories, size) => categories.slice(0, size));
export const getCategoryIds = createSelector([getCategories], (categories) => {
    return getMixedIds(categories);
});
export const getCategoriesMap = createSelector([getCategories], (categories) => getMixedIdsMap(categories));
export const getCategoryCount = (state) => getCategories(state).length;
export const getCategory = (state, id) => getCategoriesMap(state)[id];
export const getMainCategory = (state, post = {}) => { var _a; return (_a = post.mainCategory) !== null && _a !== void 0 ? _a : resolveMainCategory(state, post); };
export const getMainCategoryDisplayLabel = getMainCategoryField('label', 'menuLabel');
export const getMainCategorySeoLabel = getMainCategoryField('title', 'label');
export const getMainCategoryLink = (state, post = {}, topology = {}) => {
    if (post.mainCategory) {
        return post.mainCategory.link;
    }
    const mainCategory = resolveMainCategory(state, post);
    if (mainCategory) {
        return getInternalLinkRoute({
            topology,
            to: `/${ROUTE_PREFIX_CATEGORIES}/${mainCategory.slug}`,
            shouldNavigateToFeed: true,
        });
    }
    return undefined;
};
export const getCategoryBySlug = createSelector([getCategories, (_, slug) => slug], (categories, categorySlug) => find(categories, (category) => includes(category.slugs, categorySlug) ||
    includes(category.slugs, `${categorySlug}/`)));
export const getHighestRank = createSelector([getCategories], (categories) => Math.max(-1, ...map(categories, (category) => { var _a; return (_a = category.rank) !== null && _a !== void 0 ? _a : -1; })));
export const getCategoryByTranslationSlug = createSelector([
    getCategories,
    (_, slug) => slug,
    (_, __, language) => language,
], (categories, translationSlug, language) => categories.find((category) => {
    var _a;
    return category.language === language &&
        ((_a = category.translations) === null || _a === void 0 ? void 0 : _a.find(({ url }) => { var _a; return (_a = url === null || url === void 0 ? void 0 : url.path) === null || _a === void 0 ? void 0 : _a.includes(translationSlug); }));
}));
function resolveMainCategory(state, post = {}) {
    var _a;
    const mainCategoryId = (_a = post.categoryIds) === null || _a === void 0 ? void 0 : _a[0];
    if (mainCategoryId) {
        return getCategory(state, mainCategoryId);
    }
    return undefined;
}
function getMainCategoryField(mainCategoryField, fallbackCategoryField) {
    return (state, post = {}) => {
        if (post.mainCategory) {
            return post.mainCategory[mainCategoryField];
        }
        const mainCategory = resolveMainCategory(state, post);
        if (mainCategory) {
            return mainCategory[fallbackCategoryField];
        }
        return undefined;
    };
}
//# sourceMappingURL=categories-selectors.js.map